/**
 * created by lei lei on 2020/5/29
 */
import React, { Component } from 'react';
import ActivityCompletion from './ActivityCompletion';
import { headers } from "../../../../actions";
import { connect } from 'react-redux'
import Card from '../../../components/card/Card'
import {permissionCheck} from "../../../../utils";
import  * as utils from'../../../../utils/index'

let option = {
    title: {
        text: '单位：篇',//头部文字显示
        left: 28,
        top: 23,
        textStyle: {
            fontSize: '12',
            fontFamily: 'Microsoft YaHei',
            color: '#9ea5bd'
        }
    },
    tooltip: {
        trigger: 'axis',
        show: true,// 必须引入 tooltip 组件,
    },
    color: ['#566eff', '#0d93fd', '#ff9600', '#39d3ab'],
    legend: {
        left: 40,//提示定位
        top: -3,
        show: true,
        data: ['已发派', '已提交', '已完成', '进行中']
    },
    grid: {
        left: '3%',
        right: '4%',
        bottom: '0',
        containLabel: true
    },
    toolbox: {
        show: true,
        showTitle: false,
        feature: {}
    },
    xAxis: {
        type: 'category',
        boundaryGap: false,
        axisLabel: {
            textStyle: {
                fontFamily: 'MicrosoftYaHei',
                color: '#9ea5bd',
            },
        },
        axisLine: {
            show: true, //隐藏坐标轴
            lineStyle: {
                color: '#f4f6fc',  //坐标轴的颜色
            },
        },
        data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
    },
    yAxis: {
        type: 'value',
        axisLabel: {
            textStyle: {
                fontFamily: 'MicrosoftYaHei',
                color: '#9ea5bd',
            },
        },
        axisLine: {
            show: true, //隐藏坐标轴
            lineStyle: {
                color: '#f4f6fc',  //坐标轴的颜色
            },
        },
        splitLine: {
            show: true,   // 网格线是否显示
            //  改变样式
            lineStyle: {
                color: '#f4f6fc'   // 修改网格线颜色     
            }
        },
        //max:100
        // minInterval : 1,
        // boundaryGap : [ 0, 0.3 ],
    },
    series: [
        {
            name: '已发派',
            type: 'line',
            smooth: true,
            /*  stack: '总量',*/
            itemStyle: {
                normal: {
                    //  color:'none',
                    lineStyle: {
                        color: 'none' //改变折线颜色
                    }
                },
            },
            areaStyle: {
                color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                   /* colorStops: [{
                        offset: 0, color: 'rgba(83,107,255)',// 0% 处的颜色
                    }, {
                        offset: 0.82, color: 'rgba(122,143, 255)', opacity: 0.1 // 100% 处的颜色
                    }, {
                        offset: 1, color: 'rgba(139,159,255)', opacity: 0.1
                    }],*/
                    globalCoord: false // 缺省为 false
                }
            },
            data: []
        },
        {
            name: '已提交',
            type: 'line',
            smooth: true,
            /*  stack: '总量',*/
            itemStyle: {
                normal: {
                    // color:'none',
                    lineStyle: {
                        color: 'none' //改变折线颜色
                    }
                },

            },
            areaStyle: {
                color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                   /* colorStops: [{
                        offset: 0, color: '#80c8ff' // 0% 处的颜色
                    }, {
                        offset: 1, color: '#799aed' // 0% 处的颜色
                    }],*/
                    globalCoord: false // 缺省为 false
                },
            },
            data: []
        },
        {
            name: '已完成',
            type: 'line',
            smooth: true,
            /*  stack: '总量',*/
            itemStyle: {
                normal: {
                    //   color:'none',
                    lineStyle: {
                        color: 'none' //改变折线颜色
                    }
                }
            },
            areaStyle: {
                color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                   /* colorStops: [{
                        offset: 0, color: 'rgba(255,150,0,0.7)' // 0% 处的颜色
                    }, {
                        offset: 1, color: 'rgba(255,150,0,0.2)' // 0% 处的颜色
                    }],*/
                    globalCoord: false // 缺省为 false
                },
            },
            data: []
        },
        {
            name: '进行中',
            type: 'line',
            smooth: true,
            /*  stack: '总量',*/
            itemStyle: {
                normal: {
                    // color:'none',
                    lineStyle: {
                        color: 'none' //改变折线颜色
                    }
                }
            },
            areaStyle: {
                color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                   /* colorStops: [{
                        offset: 0, color: '#aaffdb' // 0% 处的颜色
                    }, {
                        offset: 1, color: 'rgba(170,255,219,0.8)' // 0% 处的颜色
                    }],*/
                    globalCoord: false // 缺省为 false
                },
            },
            data: []
        },

    ]
};
let option2 = {
    title: {
        text: '单位：篇',//头部文字显示
        left: 28,
        top: 23,
        textStyle: {
            fontSize: '12',
            fontFamily: 'Microsoft YaHei',
            color: '#9ea5bd'
        }
    },
    tooltip: {
        trigger: 'axis',
        show: true,// 必须引入 tooltip 组件,
    },
    color: ['#566eff', '#0d93fd', '#ff9600', '#39d3ab'],
    legend: {
        left: 40,//提示定位
        top: -3,
        show: true,
        data: ['已发派', '已提交', '已完成', '进行中']
    },
    grid: {
        left: '3%',
        right: '4%',
        bottom: '0',
        containLabel: true
    },
    toolbox: {
        show: true,
        showTitle: false,
        feature: {}
    },
    xAxis: {
        type: 'category',
        boundaryGap: false,
        axisLabel: {
            textStyle: {
                fontFamily: 'MicrosoftYaHei',
                color: '#9ea5bd',
            },
        },
        axisLine: {
            show: true, //隐藏坐标轴
            lineStyle: {
                color: '#f4f6fc',  //坐标轴的颜色
            },
        },
        data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
    },
    yAxis: {
        type: 'value',
        axisLabel: {
            textStyle: {
                fontFamily: 'MicrosoftYaHei',
                color: '#9ea5bd',
            },
        },
        axisLine: {
            show: true, //隐藏坐标轴
            lineStyle: {
                color: '#f4f6fc',  //坐标轴的颜色
            },
        },
        splitLine: {
            show: true,   // 网格线是否显示
            //  改变样式
            lineStyle: {
                color: '#f4f6fc'   // 修改网格线颜色
            }
        },
        //max:100
        // minInterval : 1,
        // boundaryGap : [ 0, 0.3 ],
    },
    series: [
        {
            name: '已发派',
            type: 'line',
            smooth: true,
            /*  stack: '总量',*/
            itemStyle: {
                normal: {
                    //  color:'none',
                    lineStyle: {
                        color: 'none' //改变折线颜色
                    }
                },
            },
            areaStyle: {
                color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [{
                         offset: 0, color: 'rgba(83,107,255)',// 0% 处的颜色
                     }, {
                         offset: 0.82, color: 'rgba(122,143, 255)', opacity: 0.1 // 100% 处的颜色
                     }, {
                         offset: 1, color: 'rgba(139,159,255)', opacity: 0.1
                     }],
                    globalCoord: false // 缺省为 false
                }
            },
            data: []
        },
        {
            name: '已提交',
            type: 'line',
            smooth: true,
            /*  stack: '总量',*/
            itemStyle: {
                normal: {
                    // color:'none',
                    lineStyle: {
                        color: 'none' //改变折线颜色
                    }
                },

            },
            areaStyle: {
                color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                     colorStops: [{
                         offset: 0, color: '#80c8ff' // 0% 处的颜色
                     }, {
                         offset: 1, color: '#799aed' // 0% 处的颜色
                     }],
                    globalCoord: false // 缺省为 false
                },
            },
            data: []
        },
        {
            name: '已完成',
            type: 'line',
            smooth: true,
            /*  stack: '总量',*/
            itemStyle: {
                normal: {
                    //   color:'none',
                    lineStyle: {
                        color: 'none' //改变折线颜色
                    }
                }
            },
            areaStyle: {
                color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                     colorStops: [{
                         offset: 0, color: 'rgba(255,150,0,0.7)' // 0% 处的颜色
                     }, {
                         offset: 1, color: 'rgba(255,150,0,0.2)' // 0% 处的颜色
                     }],
                    globalCoord: false // 缺省为 false
                },
            },
            data: []
        },
        {
            name: '进行中',
            type: 'line',
            smooth: true,
            /*  stack: '总量',*/
            itemStyle: {
                normal: {
                    // color:'none',
                    lineStyle: {
                        color: 'none' //改变折线颜色
                    }
                }
            },
            areaStyle: {
                color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                     colorStops: [{
                         offset: 0, color: '#aaffdb' // 0% 处的颜色
                     }, {
                         offset: 1, color: 'rgba(170,255,219,0.8)' // 0% 处的颜色
                     }],
                    globalCoord: false // 缺省为 false
                },
            },
            data: []
        },

    ]
};

let isIE=utils.isIE();
class ActivityCompletionComponents extends Component {
    static defaultProps = {}
    static propTypes = {}

    constructor(props) {
        super(props);
        this.state = {
            leftTitleList: [],
            data: {},
            option: {},
            option1: JSON.parse(JSON.stringify(isIE?option:option2)),
            option2: JSON.parse(JSON.stringify(isIE?option:option2)),
            option3: JSON.parse(JSON.stringify(isIE?option:option2)),
            option4: JSON.parse(JSON.stringify(isIE?option:option2)),
        }

    }

    initData() {
        getStatisticsData((res) => {
            if (res && res.value != null) {
                let data = res.value;
                let weekName = data.weekName;
                let dayName = data.dayName;
                let yearName = data.yearName;
                let mountName = data.mountName;
                this.state.option1.xAxis.data = weekName;
                this.state.option2.xAxis.data = dayName;
                this.state.option3.xAxis.data = mountName;
                this.state.option4.xAxis.data = yearName;

                this.state.option1.series[0].data = data.noget.week;
                this.state.option1.series[1].data = data.over.week;
                this.state.option1.series[2].data = data.publish.week;
                this.state.option1.series[3].data = data.get.week;


                this.state.option2.series[0].data = data.noget.day;
                this.state.option2.series[1].data = data.over.day;
                this.state.option2.series[2].data = data.publish.day;
                this.state.option2.series[3].data = data.get.day;

                this.state.option3.series[0].data = data.noget.mounthData;
                this.state.option3.series[1].data = data.over.mounthData;
                this.state.option3.series[2].data = data.publish.mounthData;
                this.state.option3.series[3].data = data.get.mounthData;

                this.state.option4.series[0].data = data.noget.yearData;
                this.state.option4.series[1].data = data.over.yearData;
                this.state.option4.series[2].data = data.publish.yearData;
                this.state.option4.series[3].data = data.get.yearData;

                this.setState({
                    option: this.state.option1,
                    leftTitleList: [data.noget.count, data.over.count, data.publish.count, data.get.count],
                })
            }
        });
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.initData();
    }
    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }


    render() {
        let newSecondSelectColor = this.props.config && this.props.config.getValueByKey ? this.props.config.getValueByKey("newSecondSelectColor", '#0050B3') : '#0050B3';
        let isAuth = permissionCheck("pms:taskCompletion:viewAll");//是否展示任务完成情况
        if(!isAuth){
            return <div></div>
        }
        return (
            <Card title=" 任务完成情况" style={{ marginTop: 20 }}>
                <ActivityCompletion
                    leftTitleList={this.state.leftTitleList}
                    leftNumKey={'num'}
                    opetion={this.state.option}
                    newSecondSelectColor={newSecondSelectColor}
                    topBtnClick={(data) => {
                        if (data === "本周") {
                            this.setState({ option: this.state.option1 })
                        } else if (data === "本月") {
                            this.setState({ option: this.state.option2 })
                        } else if (data === "本年") {
                            this.setState({ option: this.state.option3 })
                        } else if (data === "历年") {
                            this.setState({ option: this.state.option4 })
                        }
                    }}
                />

            </Card>
        )
    }
}


function mapStateToProps(state) {
    return {
        config: state.systemReducer.config,
    }
}

export default connect(mapStateToProps)(ActivityCompletionComponents)

export const getStatisticsData = (callBack) => {
    let url = "/cm-sites-pms/interview/getInterviewAcitivityCount";
    fetch(url, {
        method: 'post',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getStatisticsData", error);
        callBack("");
    })
}